import {csrfManager} from "../../../../../../lib-sat/csrf/csrf-manager";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import {cookieHelper} from "../../../../../helper/cookie";
import axios from 'axios';

class FeatureRequestManager {  
    constructor() {

    }

    showFeatureRequest() {
        const isFeatureRequestEnabled = window.resultConfig?.featureRequest;
        const requestDismiss = cookieHelper.getCookieValue('feature_request_dismiss');        
        
        if (!isFeatureRequestEnabled || requestDismiss) {
            return false;
        }
        
        return true;
    }

    async submitFeatureRequest(comment) {
        const csrfToken = await csrfManager.getCsrfFeatureRequest();
        let data = {
            _csrf: csrfToken,
            comment
        };

        const result = await axios.post(satGlobals.getApiUrl('/api/feature-request'), data, {withCredentials: true});

        return result;
    }

    dismiss() {
        const d = new Date();
        d.setTime(d.getTime() + 360 * 24 * 60 * 60 * 1000);
                
        const expires = 'expires=' + d.toUTCString();
        document.cookie = 'feature_request_dismiss=true; ' + expires;
    }
}

export default new FeatureRequestManager();
